/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

/**
 * Centralized refresh intervals for the Home tab services (bookmarks)
 * All intervals are in milliseconds
 */
export const SERVICES_REFRESH_INTERVALS = {
  // Service list refresh
  LIST: 60000, // 60 seconds

  // Live online/offline status check per tile
  STATUS: 60000, // 60 seconds

  // 30-day uptime % summary, shared across all cards -- moves slowly, no
  // need to poll as often as live status
  UPTIME: 5 * 60000, // 5 minutes
} as const;
